import type * as ThemeProps from 'styles/themeProperties';
import { KCFColor } from 'styles/themes/KCFColor';
import { KCFStyle } from 'styles/themes/KCFStyle';

// A theme property maps to a theme value, which can be any of the following types.
export type KCFThemeValue = KCFColor | KCFStyle;

/**
 * Extract all theme property names from themeProperties.ts exports.
 * Since themeProperties.ts only exports theme properties (no functions),
 * all keys are valid theme property names.
 */
type ThemePropertyNames = keyof typeof ThemeProps;

/**
 * The KCFTheme type defines the shape that all themes must conform to.
 * It is automatically derived from the exports in themeProperties.ts, so adding
 * a new theme property only requires:
 * 1. Adding the export in themeProperties.ts
 * 2. Adding the values in light.ts and dark.ts
 */
export type KCFTheme = Record<ThemePropertyNames, KCFThemeValue>;

export enum ThemeType {
    light = 'light',
    dark = 'dark',
}
